<template>
  <div>
    <div class="bottom_box">
      <div class="bottom_content"  v-if="this.qw==1">
        <div class="bottomBox_left">
          <p class="contact">联系我们</p>
          <p class="xian"></p>
          <div class="bottom_text">
            <p>电话:{{ arr.phone }}</p>
            <p>邮箱:{{ arr.mail }}</p>
            <p class="dizi">地址:{{ arr.address }}</p>
          </div>
          <div class="Record_box">
            <div class="Record">
              凤凰航运（武汉）股份有限公司&nbsp;&nbsp; &nbsp;版权所有&nbsp;&nbsp;
              &nbsp;<a href="https://beian.miit.gov.cn/" target="_Blank">鄂ICP备2020017934号-1</a>
            </div>
          </div>
        </div>
        <div class="bottomBox_left">
          <p class="contact">友情链接</p>
          <p class="xian"></p>
          <div class="bottom_text" v-for="(item, index) in list" :key="index">
            <!-- {{ item.tags }} -->
            <p>
              链接:<a target="_blank" :href="item.url">{{
                item.title
              }}</a>
            </p>
          </div>
        </div>
        <div class="bottom_text bottom_text_end">
          <div class="code_box">
            <img
              src="../../assets/newImg/code.jpg"
              alt=""
            />
          </div>
          <p class="code_text">扫描二维码关注公众号</p>
        </div>
      </div>
      <!-- 手机版本 -->
      <div class="bottom_content" v-if="this.qw==2">
        <div class="bottomBox_left" >
          <p class="contact">联系我们</p>
          <!-- <p class="xian"></p> -->
          <div class="bottom_text">
            <p>电话:{{ arr.phone }}</p>
            <p>邮箱:{{ arr.mail }}</p>
            <p class="dizi">地址:{{ arr.address }}</p>
          </div>
          <div class="Record_box">
            <div class="Record">
              凤凰航运（武汉）股份有限公司&nbsp;&nbsp; &nbsp;版权所有&nbsp;&nbsp;
              &nbsp;<a href="https://beian.miit.gov.cn/" target="_Blank">鄂ICP备2020017934号-1</a>
            </div>
          </div>
            <div class="bottomBox_left" style="margin-top:40px">
          <p class="contact">友情链接</p>
          <!-- <p class="xian"></p> -->
          <div class="bottom_text" v-for="(item, index) in list" :key="index">
            <p>
              链接:<a target="_blank" :href="item.url">{{
                item.title
              }}</a>
            </p>
          </div>
        </div>
        </div>
      
        <div class="bottom_text bottom_text_end">
          <div class="code_box">
            <img
              src="../../assets/newImg/code.jpg"
              alt=""
            />
          </div>
          <p class="code_text">扫描二维码关注公众号</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {
      cur: 1,
      arr: [],
      list: [],
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      qw: "",
    };
  },
  created() {
    this.bottomlist();
    this.bottomlistS();
    if (this.windowWidth > 1000) {
      this.qw = 1;
    } else if (this.windowWidth < 1000) {
      this.qw = 2;
    }
  },
  watch: {
    windowHeight(val) {
      let that = this;
      // console.log("实时屏幕高度：",val, that.windowHeight );

      // console.log(val, "实时屏幕高度：");
      // this.qq= val
    },
    windowWidth(val) {
      let that = this;
      console.log("实时屏幕宽度：", val, that.windowWidth);
      // console.log(val, "实时屏幕宽度：");
      if (that.windowWidth > 1000) {
        this.qw = 1;
      } else if (that.windowWidth < 1000) {
        this.qw = 2;
      }
    },
  },
  methods: {
    bottomlist: function () {
      this.$axios({
        method: "get",
        url: "/changhang/contact/list",
      })
        .then((res) => {
          this.arr = res.data.rows[0];
          // console.log(res);
        })
        .catch((res) => {
          console.log("1111111" + res);
        });
    },
    bottomlistS: function () {
      this.$axios({
        method: "get",
        url: "/changhang/index/list?menu=7&type=61",
      })
        .then((res) => {
          this.list = res.data.rows;
          // console.log(res);
        })
        .catch((res) => {
          console.log("1111111" + res);
        });
    },
  },
};
</script>
<style>
/* #fontset{font-size:5vw;} */
.dizi {
  /* width: 24vw; */
}
.bottom_box {
  width: 100%;
  height: 12vw;
  padding-bottom: 30px;
  background-color: #cccccc;
  overflow: hidden;
}
.index {
  display: flex;
  justify-content: space-between;
  width: 1000px;
  margin: auto;
  margin-top: 20px;
}
.index_img2 {
  width: 22%;
  height: 10vw;
  background-color: #0c47a1;
}
.index_img2:hover {
  width: 23%;
  height: 11vw;
}
.index_img {
  width: 22%;
  height: 10vw;
}
.index_img:hover {
  width: 23%;
  height: 11vw;
}
.index_img img {
  width: 100%;
  height: 100%;
}
.logo_box {
  width: 23%;
  /* height: 3vw; */
  margin: 0 auto;
  color: #0c47a1;
  background-color: #3d3d3d;
  border-radius: 50%;
  text-align: center;
  line-height: 3vw;
  margin-top: 20px;
  font-size: 1vw;
}

.index_botton {
  width: 100%;
  height: 4vw;
  margin-top: 10px;
  text-align: center;
}
.index_text {
  color: #3d3d3d;
  font-size: 1.5vw;
}
.index_digital {
  color: #f10513;
  font-size: 1.5vw;
}
.bottom_content {
  width: 1000px;
  margin: auto;
  display: flex;
  margin-top: 2%;
  justify-content: space-between;
  /* height: 7vw;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  margin-top: 20px; */
}
.bottomBox_left {
  /* flex: 1; 
   width: 30%; 
   height: 100%;  */
  margin-top: 10px;
}
.contact {
  font-size: 20px;
  color: #3d3d3d;
}
.xian {
  width: 27%;
  height: 1px;
  margin-top: 10px;
  background: #3d3d3d;
}
.bottom_text {
  /* flex:1; */
  color: #3d3d3d;
  font-size: 16px;
  margin-top: 10px;
}
.code_box {
  width: 80px;
  height: 80px;
  /* margin-left: 31%; */
}
.code_box img {
  width: 100%;
  height: 100%;
}
.code_text {
  font-size: 16px;
  margin-top: 10px;
  margin-left: -40px;
}
.Record_box {
  margin: 0 auto;
  /* border-top: 1px solid #5486c5; */
}
.Record {
  margin: 0 auto;
  margin-top: 10px;
  color: #3d3d3d;
  font-size: 16px;
}
@media screen and (min-width: 320px) and (max-width: 750px) {
  .bottom_box {
    height: 350px;
  }
  .code_text {
    margin-left: 0%;
  }
  .bottom_content {
    width: 100%;
    /* height: 151px; */
    display: flex;
      justify-content: space-between;
    color: #707070;
  }
  .code_text{
    font-size: 12px;
  }
  .bottom_text{
    margin-right: 2%;
  }
  .bottom_content .contact{
    color: #000;
  }
 .bottomBox_left{
   margin-left: 2%;
   width: 209px;
 }
 .bottom_text{
   font-size: 12px;
 }
 .Record{
   font-size: 12px;
 }
 .code_box{
   width: 129px;
   height: 129px;
 }
}
/* @media screen and (max-width: 768px) {
  .bottom_content {
    width: 96% !important;
  }
  .bottom_box,
  .bottom_content {
    height: auto;
  }
  .bottom_text {
    margin-top: 0;
  }
  .code_text {
    width: 50px;
    margin-left: 0;
  }
  .bottom_text_end{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .Record_box{
    width:96%;
  }
  .Record{
    width: 100%;
  }
} */
</style>



// WEBPACK FOOTER //
// src/components/haed/footer.vue